import { RemunerationStatementEntityType } from "../../../../../Wrap/Constants/Enums/Report/RemunerationStatementEntityType";
import { TaskRequestStatus } from "../../../../../Wrap/Constants/Enums/Tasks/TaskRequestStatus";

export enum ReportType {
    RemunerationStatement,
}

export const ReportTypeArray = [ReportType.RemunerationStatement];

export const ReportTypeMap = {
    [ReportType.RemunerationStatement]: "Remuneration Statement",
};

export const TaskRequestStatusMap = {
    [TaskRequestStatus.Allocated]: "Allocated",
    [TaskRequestStatus.Cancelled]: "Cancelled",
    [TaskRequestStatus.Complete]: "Complete",
    [TaskRequestStatus.DocumentPending]: "Document Pending",
    [TaskRequestStatus.Failed]: "Failed",
    [TaskRequestStatus.Pending]: "Pending",
    [TaskRequestStatus.Running]: "Running",
    [TaskRequestStatus.PendingDelayed]: "PendingDelayed",
    [TaskRequestStatus.CancelledRestore]: "CancelledRestore",
    [TaskRequestStatus.PendingHold]: "PendingHold",
};
export const RemunerationStatementEntityTypeMap = {
    [RemunerationStatementEntityType.NotSpecified]: "-",
    [RemunerationStatementEntityType.Network]: "Network",
    [RemunerationStatementEntityType.Company]: "Company",
};
export const DefaultMaximum = 999999;
